export default __webpack_public_path__ + "static/media/ian_harris.beccff76.jpg";